/**
 * @generated SignedSource<<587be2d9f775adb8b3e3dc02b4d5a7a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeoFundableCases_geo$data = {
  readonly caseArticles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"GeoFundableCases_item">;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "GeoFundableCases_geo";
};
export type GeoFundableCases_geo$key = {
  readonly " $data"?: GeoFundableCases_geo$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeoFundableCases_geo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeoFundableCases_geo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "articleStatus",
          "value": "NOT_YET_FUNDED"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        }
      ],
      "concreteType": "CaseArticleConnection",
      "kind": "LinkedField",
      "name": "caseArticles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CaseArticleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CaseArticle",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GeoFundableCases_item"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "caseArticles(articleStatus:\"NOT_YET_FUNDED\",first:3)"
    }
  ],
  "type": "State",
  "abstractKey": null
};

(node as any).hash = "3bc829ebd3591d8cb32e48100cc05a5d";

export default node;
